import axios from 'axios'
import errorParser from '@/utils/error-parser'

export default {
  /**
   * Admin-only listing of recent anomalies.
   * @param {Object} opts { limit, includeDismissed }
   */
  listAnomalies (opts = {}) {
    return new Promise((resolve, reject) => {
      const params = {
        limit: opts.limit != null ? opts.limit : 200,
        includeDismissed: opts.includeDismissed === true
      }
      axios.get('/anomalies', { params }).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  dismissAnomaly (id) {
    return new Promise((resolve, reject) => {
      axios.patch('/anomalies/' + id + '/dismiss').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  }
}
